// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tdkB","footer":"styles_footer__vmBwv","passCodeTooltip":"styles_passCodeTooltip__1Pagx"};